import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "theme/ThemeContext";
import Toast from "style-guide/component/Toast";
import ErrorModal from "style-guide/component/Error";
import { Spin } from "antd";
import AppRoutes from "routes/AppRoutes";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Toast />
        <ErrorModal />
        <Suspense
          fallback={
            <div className="flex h-screen items-center justify-center">
              <Spin />
            </div>
          }
        >
          <AppRoutes />
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
